import { render, staticRenderFns } from "./PropertyTypeField.vue?vue&type=template&id=1a98fde8&"
import script from "./PropertyTypeField.vue?vue&type=script&lang=js&"
export * from "./PropertyTypeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports